var React = require('react');

function Star1 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","fill":"none","key":0}),React.createElement("path",{"d":"M11.389,2.5l2.95,5.9,6.521.983-4.7,4.629,1.08,6.506-5.854-3.038L5.535,20.515l1.08-6.506L1.917,9.38,8.438,8.4Z","transform":"translate(-1.389 -1.904)","fill":"#bdff3b","fillRule":"evenodd","key":1})]);
}

Star1.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Star1;

Star1.default = Star1;
